import { render } from "./ToolbarCustomized.vue?vue&type=template&id=0c30f6fe"
import script from "./ToolbarCustomized.vue?vue&type=script&lang=js"
export * from "./ToolbarCustomized.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__